module.exports = __webpack_public_path__ + "img/KSC01526.59c8b784.jpg";